import {
  ChangeDetectionStrategy,
  Component,
  inject,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { ToastExtendedService } from '../toast-extended.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DsButtonModule } from '@bmw-ds/components';

@Component({
  selector: 'tqc-error-toast',
  templateUrl: 'error-toast.component.html',
  imports: [TranslatePipe, DsButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorToastComponent {
  public readonly errorToastTemplate =
    viewChild.required<TemplateRef<unknown>>('errorToast');

  private readonly toastExtendedService = inject(ToastExtendedService);

  public copy(): void {
    void navigator.clipboard.writeText(
      this.toastExtendedService.getErrorText()
    );
  }
}
